import api from 'services/api';
import {
  IResponseBiometricParameters,
  IResponseBiometricsNurseries,
  IResponseHealthMortality,
  IResponseNurseryMortality,
  IResponseQualityParameters,
  IResponseSupply,
  IResponseWaterAnalysisNurseries,
} from 'v2/resources/types/graphics';
import { HttpCodes } from 'v2/resources/types/httpCode';
import {
  DEFAULT_RESPONSE_BIOMETRICS_NURSERIES,
  DEFAULT_RESPONSE_BIOMETRICS_PARAMETERS,
  DEFAULT_RESPONSE_HEALTH_MORTALITY,
  DEFAULT_RESPONSE_NURSERY_MORTALITY,
  DEFAULT_RESPONSE_QUALITY_PARAMETERS,
  DEFAULT_RESPONSE_SUPPLY,
  DEFAULT_RESPONSE_WATER_ANALYSIS_NURSERIES,
} from './type';

export const GraphicsServices = {
  getSupply: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_SUPPLY;
    const response = await api.get<IResponseSupply>(
      `charts/input-supply/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_SUPPLY;
  },
  getNurseryMortality: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_NURSERY_MORTALITY;
    const response = await api.get<IResponseNurseryMortality[]>(
      `charts/mortalities/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_NURSERY_MORTALITY;
  },
  getHealthAnalysis: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_HEALTH_MORTALITY;
    const response = await api.get<IResponseHealthMortality>(
      `charts/healthmeasures/ponds/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_HEALTH_MORTALITY;
  },
  getWaterQualityParameters: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_QUALITY_PARAMETERS;
    const response = await api.get<IResponseQualityParameters>(
      `charts/measurements/parameters/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_QUALITY_PARAMETERS;
  },
  getBiometricsParameters: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_BIOMETRICS_PARAMETERS;
    const response = await api.get<IResponseBiometricParameters>(
      `charts/biomeasures/parameters/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_BIOMETRICS_PARAMETERS;
  },
  getBiometricsNurseries: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_BIOMETRICS_NURSERIES;
    const response = await api.get<IResponseBiometricsNurseries>(
      `charts/biomeasures/ponds/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_BIOMETRICS_NURSERIES;
  },
  getWaterAnalysisNurseries: async (cicleId: number | string) => {
    if (!cicleId) return DEFAULT_RESPONSE_WATER_ANALYSIS_NURSERIES;
    const response = await api.get<IResponseWaterAnalysisNurseries>(
      `charts/measurements/ponds/${cicleId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_WATER_ANALYSIS_NURSERIES;
  },
};
